<mat-card>
  <mat-card-title>
    <p8-layout-settings-header [titlePath]="['Notifications']" [iconRacine]="'add_alert'"></p8-layout-settings-header>
  </mat-card-title>
    <mat-card-content *ngIf="config" fxLayout="column">
      <mat-checkbox [(ngModel)]="config.config.notif_demandeur" (change)="updateCfg()">Recevoir les notifications sur les DAR où je suis le demandeur</mat-checkbox>
      <mat-checkbox [(ngModel)]="config.config.notif_contact" (change)="updateCfg()">Recevoir les notifications sur les DAR où je suis en contact</mat-checkbox>
    </mat-card-content>
    <mat-card-content *ngIf="config && hasRoleFonctionnel" fxLayout="column">
      <mat-label>Pour les gestionnaires:</mat-label>
      <mat-checkbox [(ngModel)]="config.config.notif_change_value" (change)="updateCfg()">Recevoir les notifications suite à une modification de valeurs des DAR où je suis gestionnaire</mat-checkbox>
      <mat-checkbox [(ngModel)]="config.config.notif_change_step" (change)="updateCfg()">Recevoir les notifications suite à un changement d'état des DAR où je suis gestionnaire</mat-checkbox>
      <mat-checkbox [(ngModel)]="config.config.notif_comment" (change)="updateCfg()">Recevoir les notifications suite à un commentaire sur les DAR où je suis gestionnaire</mat-checkbox>
    </mat-card-content>
</mat-card>
